export enum PoliticsPerformanceCategory {
	Midterms = 'midterms',
	SenateElections = 'senate_elections',
	HouseElections = 'house_elections',
	GovernorElections = 'governor_elections',
}

export const POLITICS_PERFORMANCE_CATEGORY_LABELS: Record<PoliticsPerformanceCategory, string> = {
	[PoliticsPerformanceCategory.Midterms]: 'Midterms',
	[PoliticsPerformanceCategory.SenateElections]: 'Senate Elections',
	[PoliticsPerformanceCategory.HouseElections]: 'House Elections',
	[PoliticsPerformanceCategory.GovernorElections]: 'Governor Elections',
};
